import { PostHogProvider as PostHogProviderBase } from 'posthog-js/react'
import { posthogClient } from '@/api/posthog'

export const PostHogCustomProvider = ({ children }: { children: React.ReactNode }) => {
  if (!posthogClient) {
    return children
  }

  return <PostHogProviderBase client={posthogClient}>{children}</PostHogProviderBase>
}
